<template>
  <div id="app">
      <MainGrid v-show="!plsRotate" @update_lg="updateLg" @update_p="updateP" @update_tf="updateTf" @darkmode="dark = true" @white="white= true" @reset="dark = false, white = false" :gd_projects="gd_projects" :perform_projects="perform_projects" :tf_projects="tf_projects"></MainGrid>

      <transition name="fade">
      <div v-show="dark" class="dark">
        </div>
      </transition>

      <transition name="fade">
      <div v-show="!dark && !white" class="light">
        </div>
      </transition>

      <!-- <transition name="fade">
      <div v-show="white" class="white">
        </div>
      </transition> -->

    <div v-if="lg" id="frame" ref="popup" style="background-color: #01D0B4; margin-left:-18vw">
      <div v-bar class="popupcontainer">
        <div class="popupcontent">
        <div id="click" @click="lg = false">
          X
        </div>
        <p style="white-space: pre-wrap" v-html="popuptexts[0].content"></p>
      </div>
      </div>
    </div>


    <div v-show="p" id="frame" ref="popup" style="background-color: #17C674; margin-left:8vw; margin-top:-10vh">
      <div v-bar class="popupcontainer">
        <div class="popupcontent">
          <div id="click" @click="p = false">
            X
          </div>
        <p style="white-space: pre-wrap" v-html="popuptexts[1].content"></p>
        </div>
      </div>
    </div>

    <div v-show="tf" id="frame" ref="popup" style="background-color: #2AD6DB; margin-top:8vh; margin-left:28vw;">
      <div v-bar class="popupcontainer">
        <div class="popupcontent">
          <div id="click" @click="tf = false">
            X
          </div>
        <img src="uploads/stageexample-01.png" style="position:relative; width:80%;margin-left:20%;margin-top:-20px"/>
        <p style="white-space: pre-wrap" v-html="popuptexts[2].content"></p>
        </div>
      </div>
    </div>

      <RotatePls v-show="plsRotate">
      </RotatePls>
  </div>

</template>

<script>
import MainGrid from './components/MainGrid.vue'
import '../src/assets/css/leonie_scrollbar.css';
import axios from 'axios'
import RotatePls from './components/RotatePls.vue'

export default {
  name: 'app',
  components: {
    MainGrid, RotatePls
  },
  data () {
    return {
      projects: [],
      dataLoaded: false,
      gd_projects: [],
      perform_projects: [],
      tf_projects: [],
      popuptexts: [],
      lg: false,
			p: false,
      tf: false,
      window: {width: 0, height: 0},
      mobile: false,
      plsRotate: false,
      dark: false,
      white: false,
    }
  },
  created () {
    window.addEventListener('resize', this.handleResize);
  },
  mounted () {
    this.handleResize();
    var self = this;
    axios.get('https://leoniegores.dev0ted.tech/projects')
      .then(function (response) {
        self.projects = response["data"];
          self.dataLoaded = true;
          // window.console.log(self.projects);
          self.compute_gd_projects(self.projects);
          self.compute_perform_projects(self.projects);
          self.compute_tf_projects(self.projects);
        window.console.log("data can be processed");
      })
    
    axios.get('https://leoniegores.dev0ted.tech/popuptexts')
    .then(function (response) {
      self.popuptexts = response["data"];
    })
  },
  destroyed () {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    compute_gd_projects: function(input) {
      this.gd_projects = input.filter(function(project) {return project.categories[0].name == 'design';})
    },
    compute_perform_projects: function(input) {
      this.perform_projects = input.filter(function(project) {return project.categories[0].name == 'performance';})
    },
    compute_tf_projects: function(input) {
      this.tf_projects = input.filter(function(project) {return project.categories[0].name == 'event';})
    },
    updateLg: function() {
      this.lg = true;
    },
    updateP: function() {
      this.p = true;
    },
    updateTf: function() {
      this.tf = true;
    },
    handleResize: function() {
      this.window.width = window.innerWidth;
      window.console.log(this.plsRotate);
      if (this.window.width <= 800) {
        this.mobile = true;
        this.plsRotate = false;
        if (window.innerHeight > window.innerWidth){
          this.plsRotate = true;
        }
        else {
          this.plsRotate = false;
        }
      }
      else {
        this.mobile = false;
        this.plsRotate = false;
      }
    },
  }
}

</script>

<style lang="scss">

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.7s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

.popupcontainer {
  position:absolute;
  width:100%;
  height:100%;
}

.popupcontent p{
  margin:20px;
}

#click {
    margin-top:20px;
    width:30px;
    top:20px;
    left:20px;
    position:sticky;
}

#click:hover {
    cursor:pointer;
}

video {
  position:fixed;
  top:0px;
  z-index:-2;
}

#frame {
  width:35vw;
	height:70vh;
	left:28vw;
	top:15vh;
  position:absolute;
  z-index:1000;
	box-shadow: inset 0 0 10px lightgrey; 
	border-radius: 25px;
	box-sizing: border-box;
	margin:10px;
}

a:hover, a, a:visited{
  text-decoration: none;
  color:green;
}

@font-face {
  font-family: Sporting;
  src: url(assets/fonts/Sporting_Grotesque-Regular.woff);
}

@font-face {
  font-family: SportingBold;
  src: url(assets/fonts/SportingGrotesque-Bold.otf);
}

@font-face {
  font-family: Kamu;
  src: url(assets/fonts/AkuCintaKamu.woff);
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: Sporting, sans-serif;
  font-size:11.5pt;
  line-height: 1.4;
  // background-color: #F7F7F7;
  position: fixed;
  overflow: hidden;
}

.dark {
  position:fixed;
  z-index:-10;
  top:0;
  width:100%;
  height:100%;
  animation: pulse 35s infinite;
}

.white {
  animation: whitepulse 15s infinite;
  position:fixed;
  z-index:-15;
  top:0;
  width:100%;
  height:100%;
}

.light {
  // animation: lightpulse 35s infinite;
  background-color:#e8e8e8;
  position:fixed;
  z-index:-15;
  top:0;
  width:100%;
  height:100%;
}

@keyframes pulse {
  0% {
    background-color: rgb(5, 19, 36);
  }
  50% {
    background-color: #16373B;
  }
  100% {
    background-color: rgb(5, 19, 36);
  }
}

@keyframes whitepulse {
  0% {
    background-color: rgba(255, 255, 255, 0.979);
  }
  50% {
    background-color:rgb(231, 231, 231);
  }
  100% {
    background-color:rgba(255, 255, 255, 0.979);
  }
}

@media only screen and (max-width: 800px) {
  body {
    font-size:10.5px;
  }

  .smaller {
    font-size:8.5px;
  }
}
</style>
